import { IFormViewForm } from 'components/FormView';

const DeliveryDetailsForm: IFormViewForm = {
  id: 'DeliveryDetails',
  layout: {
    rows: 2,
    columns: 3
  },
  fields: [
    {
      id: '1',
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        name: 'siteData'
      },
      position: {
        row: 1,
        col: 1
      },
      children: [
        {
          id: '1',
          type: 'TEXT_FIELD',
          visible: true,
          props: {
            label: 'Site',
            name: 'SiteCode',
            size: 'small',
            required: true,
            inputProps: {
              maxLength: 8
            }
          },
        },
        {
          type: 'TEXT_FIELD',
          props: {
            label: 'Name',
            required: true,
            name: 'Name',
            fullWidth: true,
            inputProps: {
              maxLength: 35
            }
          }
        },
        {
          id: '3',
          type: 'EX_LOOKUP_FIELD',
          visible: true,
          props: {
            label: 'Default warehouse',
            name: 'DefaultWarehouse',
            lookupName: 'WarehouseEntity',
            size: 'small',
            inputProps: {
              maxLength: 3
            }
          }
        },
        {
          id: '4',
          type: 'EX_LOOKUP_FIELD',
          visible: true,
          props: {
            label: 'Sales entity',
            name: 'SalesEntity',
            lookupName: 'SalesEntity',
            required: false,
            size: 'small',
            inputProps: {
              maxLength: 3
            }
          }
        },
        {
          id: '5',
          type: 'TOGGLE_FIELD',
          visible: true,
          props: {
            label: 'Primary address',
            name: 'Primary',
            required: false
          }
        }
      ]
    },
    {
      type: 'PAPER_CONTAINER',
      props: {
        label: 'Address',
        name: 'address',
        required: true,
      },
      children: [
        {
          type: 'ADDRESS_BLOCK_EX',
          props: {
            name: 'address'
          }
        }
      ],
      position: {
        row: 1,
        col: 2
      },
    },
    {
      type: 'PAPER_CONTAINER',
      props: {
        label: 'Site contact details',
        name: 'siteContactDetails',
        required: true,
      },
      position: {
        row: 1,
        col: 3
      },
      children: [
        {
          type: 'TEXT_FIELD',
          props: {
            label: 'Site contact',
            name: 'Contact',
            required: false,
            fullWidth: true,
            inputProps: {
              maxLength: 20
            }
          }
        },
        {
          type: 'ACTION_FIELD',
          props: {
            label: 'Phone',
            name: 'Phone',
            required: false,
            size: 'medium',
            action: {
              iconName: 'Phone',
            },
            inputProps: {
              maxLength: 20
            }
          }
        },
        {
          type: 'ACTION_FIELD',
          props: {
            label: 'Mobile',
            name: 'PhoneMobile',
            required: false,
            size: 'medium',
            action: {
              iconName: 'Phone',
            },
            inputProps: {
              maxLength: 20
            }
          }
        },
        {
          type: 'ACTION_FIELD',
          props: {
            label: 'Fax',
            name: 'Fax',
            required: false,
            size: 'medium',
            action: {
              iconName: 'Phone',
            },
            inputProps: {
              maxLength: 20
            }
          }
        },
        {
          type: 'ACTION_FIELD',
          props: {
            label: 'Email',
            type: 'email',
            name: 'Email',
            required: false,
            size: 'large',
            action: {
              iconName: 'Mail',
            },
            inputProps: {
              maxLength: 100
            }
          }
        }
      ]
    },
    {
      type: 'PAPER_CONTAINER',
      props: {
        label: 'Site settings',
        name: 'alertInfo',
      },
      position: {
        row: 2,
        col: 2
      },
      children: [
        {
          type: 'EX_LOOKUP_FIELD',
          props: {
            label: 'Sales territory',
            name: 'SalesTerritory',
            lookupName: 'SalesTerritory',
            required: false,
            size: 'small',
            inputProps: {
              maxLength: 6
            }
          }
        },
        {
          type: 'EX_LOOKUP_FIELD',
          props: {
            label: 'Sales rep',
            name: 'SalesRepresentative',
            lookupName: 'Personnel',
            required: false,
            size: 'small',
            inputProps: {
              maxLength: 10
            }
          }
        }
      ]
    },
    {
      type: 'PAPER_CONTAINER',
      props: {
        label: 'Shipping',
        name: 'shipping',
      },
      position: {
        row: 2,
        col: 1
      },
      children: [
        {
          type: 'EX_LOOKUP_FIELD',
          props: {
            label: 'Freight code',
            name: 'FreightCode',
            lookupName: 'FreightCode',
            required: false,
            inputProps: {
              maxLength: 2
            }
          }
        },
        {
          type: 'EX_LOOKUP_FIELD',
          props: {
            label: 'Send via',
            name: 'FreightType',
            lookupName: 'FreightType',
            required: false,
            inputProps: {
              maxLength: 12
            }
          }
        },
        {
          type: 'EX_LOOKUP_FIELD',
          props: {
            label: 'Carrier',
            name: 'Carrier',
            lookupName: 'CarrierCode',
            required: false,
            inputProps: {
              maxLength: 30
            }
          }
        },
        {
          type: 'TEXT_FIELD',
          props: {
            label: 'Freight account',
            name: 'FreightAcc',
            required: false,
            fullWidth: true,
            inputProps: {
              maxLength: 15
            }
          }
        },
        {
          type: 'TEXT_FIELD',
          props: {
            label: 'Shipping instructions',
            name: 'Shipping',
            required: false,
            fullWidth: true,
            inputProps: {
              maxLength: 30
            }
          }
        }
      ]
    }
  ]
};
export default DeliveryDetailsForm;
